import React from 'react';

const Principles = () => {
  return (
    <section className="principles">
      <div className="about-container">
        <div className="taglines-section">
          <div className="taglines-header">
            <div className="taglines-overline">OUR COMMITMENT</div>
            <h3>Our Principles for Working with Clients</h3>
            <div className="taglines-underline"></div>
          </div>
          <div className="taglines-grid">
            <div className="tagline-card">
              <div className="tagline-icon">🎯</div>
              <h4>Leave everything more organized than you found it.</h4>
              <div className="tagline-description">We improve your systems and processes, not just deliver solutions.</div>
            </div>
            <div className="tagline-card">
              <div className="tagline-icon">📢</div>
              <h4>Communicate progress early and often.</h4>
              <div className="tagline-description">Regular updates and transparent communication.</div>
            </div>
            <div className="tagline-card">
              <div className="tagline-icon">📚</div>
              <h4>Share transparent documentation.</h4>
              <div className="tagline-description">Complete documentation so your team can extend our work.</div>
            </div>
            <div className="tagline-card">
              <div className="tagline-icon">🚀</div>
              <h4>Under-promise, over-deliver.</h4>
              <div className="tagline-description">Set realistic expectations and consistently exceed them.</div>
            </div>
            <div className="tagline-card">
              <div className="tagline-icon">⏰</div>
              <h4>Respect the client's time.</h4>
              <div className="tagline-description">Don't ask questions we can find the answers to, limited meetings.</div>
            </div>
            <div className="tagline-card">
              <div className="tagline-icon">📊</div>
              <h4>Deliver measurable outcomes.</h4>
              <div className="tagline-description">Track outcomes with concrete metrics that matter to your business.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Principles;
